import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../../shared';
import { InternalSharedModule } from '../shared';
import { MembershipEffects } from './store/membership.effects';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxNumberBoxModule } from 'devextreme-angular/ui/number-box';
import { DxFileUploaderModule } from 'devextreme-angular/ui/file-uploader';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxTemplateModule } from 'devextreme-angular/core';
import { MembershipLevelImportModalComponent } from './components/membership-level-import-modal/membership-level-import-modal.component';
import { MembershipLevelsComponent } from './pages/membership-levels/membership-levels.component';
import { MembershipMembersPlaceholderComponent } from './pages/membership-members-placeholder/membership-members-placeholder.component';
import * as fromMembership from './store/membership.reducer';
import { StoreModule } from '@ngrx/store';

@NgModule({
  declarations: [
    MembershipLevelsComponent,
    MembershipMembersPlaceholderComponent,
    MembershipLevelImportModalComponent,
  ],
  exports: [MembershipLevelsComponent, MembershipMembersPlaceholderComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(fromMembership.membershipFeatureKey, fromMembership.reducer),
    EffectsModule.forFeature([MembershipEffects]),
    SharedModule,
    InternalSharedModule,
    DxTemplateModule,
    DxDataGridModule,
    DxPopupModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxScrollViewModule,
    DxFileUploaderModule,
    DxButtonModule,
  ],
})
export class MembershipModule {}
